import { useQuery } from "@tanstack/react-query";
import type { ApiResponse } from "../../../types/apiResponse";
import type { ClientData } from "../types";
import withPrefix from "../../../helpers/useQueryPrefix";
import { fetchClients } from "../api/fetchClients";

export const useFetchClients = () => {
	return useQuery<ApiResponse<ClientData[]>, Error, ClientData[]>({
		queryKey: withPrefix(['clients']),
		queryFn: fetchClients,
		select: (response) => {
			if (response.status !== 200) {
				throw new Error(response.message);
			}
			return response.data as ClientData[];
		},
	})
};
